<template>
  <div>
    <!-- <Loader v-show="isLoading" /> -->
    <transition name="fade" mode="out-in">
      <Loader v-show="isLoading" />
    </transition>
    <Toast position="bottom-right" group="br" />
    <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in">
            <component :is="Component" />
        </transition>
    </router-view>
  </div>
</template>

<style lang="scss">
    * {
        margin: 0;
        padding: 0;
        font-family: 'Poppins', sans-serif;
    }

    .fade-enter-active,
    .fade-leave-active {
    transition: opacity 0.5s ease;
    }


    .fade-enter-from,
    .fade-leave-to {
    opacity: 0;
    }
</style>

<script>
import { computed, defineAsyncComponent, watch } from 'vue'
import { useStore } from 'vuex'
import { useToast } from "primevue/usetoast"

export default {
    components: {
        Loader: defineAsyncComponent(() => import('@/components/Loader')),
        Toast: defineAsyncComponent(() => import('primevue/toast')),
    },
    setup() {
      const store = useStore()
      const toast = useToast()

      watch(
        () => store.getters['general/getToast'],
        (toastParameters) => {
          if (toastParameters) {
            toast.add({
              severity: toastParameters.severity,
              summary: toastParameters.summary,
              detail: toastParameters.detail,
              group: "br",
              life: 6000,
            });
          }
        }
      )

      return {
        isLoading: computed(() => store.getters['general/currentLoading'] )
      }

    }
}
</script>